export type RedeemData = {
  customToken: string;
  scanId: string;
  name?: string;
  timestamp?: number | null;
  pipelineStatus?: string | null;
};
export type RedeemErrorCode =
  | "TICKET_INVALID"
  | "TICKET_EXPIRED"
  | "TICKET_REVOKED"
  | "RATE_LIMITED"
  | "RENEW_LIMIT"
  | "NO_EMAIL"
  | "NETWORK";
export type RedeemResult =
  | { ok: true; data: RedeemData }
  | { ok: false; code: RedeemErrorCode };

const endpoint = () => process.env.REACT_APP_REDEEM_ENDPOINT || "";

async function post(url: string, ticket: string): Promise<Response> {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ticket }),
  });
}

function codeFrom(
  status: number,
  body: { code?: string } | null
): RedeemErrorCode {
  const known: RedeemErrorCode[] = [
    "TICKET_INVALID",
    "TICKET_EXPIRED",
    "TICKET_REVOKED",
    "RATE_LIMITED",
    "RENEW_LIMIT",
    "NO_EMAIL",
  ];
  if (body?.code && (known as string[]).includes(body.code)) {
    return body.code as RedeemErrorCode;
  }
  if (status === 410) return "TICKET_EXPIRED";
  if (status === 429) return "RATE_LIMITED";
  return "TICKET_INVALID";
}

export async function redeemTicket(ticket: string): Promise<RedeemResult> {
  const url = endpoint();
  if (!url) return { ok: false, code: "NETWORK" };
  try {
    const res = await post(url, ticket);
    if (res.ok) {
      const data = (await res.json()) as RedeemData;
      return { ok: true, data };
    }
    const body = await res.json().catch(() => null);
    return { ok: false, code: codeFrom(res.status, body) };
  } catch {
    return { ok: false, code: "NETWORK" };
  }
}

export async function renewTicket(
  ticket: string
): Promise<{ ok: true } | { ok: false; code: RedeemErrorCode }> {
  const url = endpoint();
  if (!url) return { ok: false, code: "NETWORK" };
  try {
    const res = await post(`${url}/renew`, ticket);
    if (res.ok) return { ok: true };
    const body = await res.json().catch(() => null);
    return { ok: false, code: codeFrom(res.status, body) };
  } catch {
    return { ok: false, code: "NETWORK" };
  }
}
